import { useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import '../styles/TerrainMap.css';
import { stupaService, StupaLocation } from '../services/stupaService';

mapboxgl.accessToken = 'pk.eyJ1IjoiYmVuamEtcGF1bHMiLCJhIjoiY201ZjlhN2dpNXlmbzJrb29jYjQzeG0xYiJ9.wp4kE3pLLmegPIxtB2ElHA';

const TerrainMap = () => {
  const [locations, setLocations] = useState<StupaLocation[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mapContainer = useRef<HTMLDivElement>(null);
  const map = useRef<mapboxgl.Map | null>(null);

  useEffect(() => {
    if (mapContainer.current) {
      map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
        center: [-70.6, -33.4],
        zoom: 7
      });

      map.current.on('load', () => {
        const fetchLocations = async () => {
          try {
            setIsLoading(true);
            setError(null);
            console.log("Fetching stupa locations...");
            const data = await stupaService.getStupaLocations();
            console.log("Received locations:", data);
            
            // Only use API locations (remove potential/donation locations)
            setLocations(data);
            
            // Add markers for active locations only
            data.forEach(location => {
              console.log("Adding marker for location:", location);
      const markerElement = document.createElement('div');
      markerElement.className = `marker ${location.type}`;
      
      const banner = document.createElement('div');
      banner.className = 'marker-banner';
      const nameSpan = document.createElement('span');
      nameSpan.textContent = location.name;
      const actionSpan = document.createElement('span');
      actionSpan.className = `action-label ${location.type}`;
      actionSpan.textContent = 'View Only';
      banner.appendChild(nameSpan);
      banner.appendChild(actionSpan);
      
      markerElement.appendChild(banner);
      
      new mapboxgl.Marker(markerElement)
        .setLngLat(location.coordinates)
        .addTo(map.current!);

      // Click functionality disabled - markers are now view-only
      // markerElement.addEventListener('click', () => {
      //   if (location.type === 'active') {
      //     // Convert location ID to proper stupa ID format
      //     const stupaId = location.id.startsWith('icestupa') ? location.id : `icestupa${location.id}`;
      //     fetchStupaPopupData(stupaId);
      //     setPopupOpen(true);
      //   }
      //   // Removed donation navigation - only active stupas are clickable
      // });
    });
            if (data.length === 1) {
              map.current?.flyTo({ center: data[0].coordinates, zoom: 10 });
            } else if (data.length > 1) {
              const bounds = data.reduce(
                (currentBounds, location) => currentBounds.extend(location.coordinates),
                new mapboxgl.LngLatBounds(data[0].coordinates, data[0].coordinates),
              );
              map.current?.fitBounds(bounds, { padding: 80, maxZoom: 11 });
            }
          } catch (error) {
            console.error('Failed to fetch stupa locations:', error);
            setError('Failed to load stupa locations');
          } finally {
            setIsLoading(false);
          }
        };

        fetchLocations();
      });
    }

    return () => {
      if (map.current) {
        map.current.remove();
      }
    };
  }, []);

  return (
    <div style={{ position: 'relative', height: '100%', width: '100%' }}>
      <div ref={mapContainer} style={{ height: '100%', width: '100%' }} />
      
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(255,255,255,0.9)',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <Typography variant="h6" style={{ color: '#1976d2', textAlign: 'center' }}>
            Loading glacier locations...
          </Typography>
        </div>
      )}

      {error && (
        <div style={{
          position: 'absolute',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(244,67,54,0.9)',
          color: 'white',
          padding: '12px 20px',
          borderRadius: '8px'
        }}>
          <Typography variant="body1">{error}</Typography>
        </div>
      )}

      {!isLoading && !error && locations.length === 0 && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(255,255,255,0.94)',
          padding: '16px 20px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <Typography variant="body1" style={{ color: '#424242', textAlign: 'center' }}>
            No glacier locations are currently available.
          </Typography>
        </div>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
             `}</style>
    </div>
  );
};

export default TerrainMap;